module.exports = __webpack_public_path__ + "img/img12.94e1be1e.png";